import { LocalDate } from "./JSJodaJSON";
import { NursingQuestionId, VBPItemId } from "./ObjectIds";

export interface VBPItemsForVisit {
  vpbItems: VBPItemWithAnswer[];
}

/* OLD VBP QUESTION INTERFACES  */
export interface VBPItemWithAnswer {
  id: VBPItemId;
  name: string;
  section: string | null;
  possibleAnswers: string[] | null;
  answerDetails: VBPItemAnswer | null;
  iconUrl: string | null;
}

export interface VBPItemAnswer {
  vbpItemId: VBPItemId;
  answer: string | null;
  notes: string | null;
  date: LocalDate;
  riskLevel: number | null;
}

export interface VBPReportSubmit {
  answers: VBPItemAnswer[];
}

/* NURSING QUESTION VBP INTERFACES */
export interface NursingQuestionVBPList {
  questions: NursingQuestionVBPWithAnswer[];
}

export interface NursingQuestionVBPWithAnswer {
  id: NursingQuestionId;
  answerType: NursingQuestionAnswerType;
  name: string;
  possibleAnswers: NursingQuestionPossibleAnswer[];
  answerDetails: NursingQuestionVBPAnswer | null;
  iconUrl: string | null;
}

export interface NursingQuestionPossibleAnswer {
  text: string;
  alertText?: string;
  isTriggeringAlert: boolean;
}

export interface NursingQuestionVBPAnswer {
  nursingQuestionId: NursingQuestionId;
  answer: string | null;
  notes: string | null;
  riskLevel: number | null;
}

export interface NursingQuestionVBPReportSubmit {
  answers: NursingQuestionVBPAnswer[];
}

export enum NursingQuestionAnswerType {
  RADIO = "radio",
  CHECK = "check",
  DROPDOWN = "dropDown",
  YES_NO = "yesNo",
  TEXT_SHORT = "textShort",
  TEXT_LONG = "textLong",
  NUMBER = "number",
  TIME = "time",
  DATE = "date",
  BLOOD_PRESSURE = "bloodPressure",
}
